"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
var entities_1 = require("./entities");
var server_1 = require("../../../sources/shared/server");
var flUser = require("./user");
var flApp = require("./application");
var notifCli = require("./notification");
var paramFactory = require("./paramFactory");
var groupFactory = require("./groupKeys");
__exportStar(require("./application"), exports);
__exportStar(require("./entities"), exports);
__exportStar(require("./entity"), exports);
__exportStar(require("./fieldJson"), exports);
__exportStar(require("./fieldLinkedField"), exports);
__exportStar(require("./fieldNumber"), exports);
__exportStar(require("./fieldPointer"), exports);
__exportStar(require("./fieldRollup"), exports);
__exportStar(require("./fieldString"), exports);
__exportStar(require("./fieldUserId"), exports);
__exportStar(require("./fieldFreejson"), exports);
__exportStar(require("./interfaces"), exports);
__exportStar(require("./rootClass"), exports);
__exportStar(require("./user"), exports);
var Api = (function () {
    function Api() {
        var _this = this;
        this.restApi = server_1.default;
        this.nbInstance = 0;
        this.curListField = new Map();
        if (this.nbInstance++ > 1) {
            throw new Error("flApi is created a second time...");
        }
        this._entities = new entities_1.default();
        this._notificationClient = new notifCli.NotifCli();
        var notifInFlApi = function (msg) {
            try {
                if (!(msg instanceof Array) || msg.length === 0) {
                    return [];
                }
                if (msg[0].dbName === "logout") {
                    _this.entities.loadNewDico([]);
                    _this.parameterFactory.resetAndLoad([]);
                    _this.groupKeyFactory.resetAndLoad([]);
                }
            }
            catch (err) {
                console.error(err.stack || err);
            }
            return [];
        };
        this.restApi.addNotificationHandler("flApi_internal", notifInFlApi, 128);
        this._notificationClient.inject(this.curListField, this.restApi);
        this._paramFactory = new paramFactory.ParamFactory();
        this._groupKeys = new groupFactory.groupKeyFactory();
    }
    Object.defineProperty(Api.prototype, "entities", {
        get: function () { return this._entities; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Api.prototype, "parameterFactory", {
        get: function () { return this._paramFactory; },
        set: function (newVal) {
            throw new Error("not allowed to change parameterFactory");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Api.prototype, "groupKeyFactory", {
        get: function () { return this._groupKeys; },
        set: function (newVal) {
            throw new Error("not allowed to change groupKeyFactory");
        },
        enumerable: false,
        configurable: true
    });
    Api.getInstance = function () {
        if (!Api._instance) {
            Api._instance = new Api();
            Api._instance.parameterFactory.resetAndLoad([]);
        }
        return Api._instance;
    };
    Api.prototype.ping = function () {
        return true;
    };
    Api.prototype.traceClient = function (trace) {
        if (trace === void 0) { trace = undefined; }
        return this.restApi.getTrace(trace);
    };
    Api.prototype.addNotificationHandler = function (name, notificationHandler, notifType) {
        return this.restApi.addNotificationHandler(name, notificationHandler, notifType);
    };
    Api.prototype.getCurrentApp = function () {
        return this.restApi.getCurrentApp();
    };
    Api.prototype.IsAdmin = function () {
        return this.restApi.IsAdmin();
    };
    Api.prototype.IsFlAdmin = function () {
        return this.restApi.IsFlAdmin();
    };
    Api.prototype.IsDesigner = function () {
        return this.restApi.IsDesigner();
    };
    Api.prototype.IsRestrictedUser = function () {
        return this.restApi.IsRestrictedUser();
    };
    Api.prototype.getUID = function () {
        return this.restApi.getUID();
    };
    Api.prototype.getUserName = function () {
        return this.restApi.getUserName();
    };
    Api.prototype.getAccessLevel = function () {
        return this.restApi.getAccessLevel();
    };
    Api.prototype.getOwnerId = function () {
        return this.restApi.getOwnerId();
    };
    Api.prototype.getOwnerName = function () {
        return this.restApi.getOwnerName();
    };
    Api.prototype.getDBName = function () {
        return this.restApi.getDBName();
    };
    Api.prototype.getWebhookDico = function () {
        return this.restApi.getWebhookDico();
    };
    Api.prototype.getCallUrl = function () {
        return this.restApi.getCallUrl();
    };
    Api.prototype.getInstanceName = function () {
        return this.restApi.getInstanceName();
    };
    Api.prototype.getFileServerUrl = function () {
        return this.restApi.getFileServerUrl();
    };
    Api.prototype.getPublicApiUrl = function () {
        return this.restApi.getPublicApiUrl();
    };
    Api.prototype.setPollingFreq = function (ms) {
        if (ms === void 0) { ms = -1; }
        return this.restApi.setPollingFreq(ms);
    };
    Api.prototype.getListDef = function (id) {
        var myFList = this.curListField.get(id);
        return myFList === undefined ? null : myFList.c91;
    };
    Api.prototype.insertListDef = function (newDef) {
        return __awaiter(this, void 0, void 0, function () {
            var newSrvDef, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (newDef.name === undefined || newDef.values === undefined) {
                            throw new Error("bad arguments");
                        }
                        return [4, this.insertDocuments(90, { c91: newDef })];
                    case 1:
                        newSrvDef = _a.sent();
                        newSrvDef[0].c91.id = newSrvDef[0].id;
                        this.curListField.set(newSrvDef[0].id, newSrvDef[0]);
                        return [2, newSrvDef[0].c91];
                    case 2:
                        err_1 = _a.sent();
                        console.error(err_1.stack || err_1);
                        err_1 = err_1.stack === undefined ? new Error(err_1) : err_1;
                        throw err_1;
                    case 3: return [2];
                }
            });
        });
    };
    Api.prototype.updateListDef = function (id, newDef) {
        return __awaiter(this, void 0, void 0, function () {
            var curListDef, newSrvDef, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (newDef.limit === undefined) {
                            newDef.limit = false;
                        }
                        if (newDef.repeatable === undefined) {
                            newDef.repeatable = false;
                        }
                        if (newDef.name === undefined || newDef.values === undefined) {
                            throw new Error("bad arguments");
                        }
                        curListDef = this.curListField.get(id);
                        if (curListDef === null) {
                            throw new Error("not found");
                        }
                        curListDef.c91 = newDef;
                        return [4, this.replaceDocument(90, curListDef)];
                    case 1:
                        newSrvDef = _a.sent();
                        this.curListField.set(curListDef.id, newDef);
                        return [2, newSrvDef[0].c91];
                    case 2:
                        err_2 = _a.sent();
                        console.error(err_2.stack || err_2);
                        err_2 = err_2.stack === undefined ? new Error(err_2) : err_2;
                        throw err_2;
                    case 3: return [2];
                }
            });
        });
    };
    Api.prototype.deleteListDef = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var curListDef, newSrvDef, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        curListDef = this.curListField.get(id);
                        if (curListDef === null) {
                            throw new Error("not found");
                        }
                        return [4, this.deleteOneDocument(90, id)];
                    case 1:
                        newSrvDef = _a.sent();
                        this.curListField.delete(id);
                        return [2, newSrvDef[0].c91];
                    case 2:
                        err_3 = _a.sent();
                        console.error(err_3.stack || err_3);
                        err_3 = err_3.stack === undefined ? new Error(err_3) : err_3;
                        throw err_3;
                    case 3: return [2];
                }
            });
        });
    };
    Api.prototype.getInstanceProviderUrl = function () {
        return this.restApi.getInstanceProviderUrl();
    };
    Api.prototype.loadInstancesList = function (myUrl, instanceProviderUrl) {
        if (instanceProviderUrl === void 0) { instanceProviderUrl = ""; }
        return this.restApi.getAvailableInstances(myUrl, instanceProviderUrl);
    };
    Api.prototype.login = function (loginData) {
        return this.restApi.login(loginData);
    };
    Api.prototype.use = function (domain, bDicoOnly) {
        if (bDicoOnly === void 0) { bDicoOnly = undefined; }
        return __awaiter(this, void 0, void 0, function () {
            var useData, err_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.restApi.Use(domain, false, bDicoOnly)];
                    case 1:
                        useData = _a.sent();
                        this.freeCxionData();
                        useData.listFields.forEach(function (aListField) {
                            return _this.curListField.set(aListField.id, aListField);
                        });
                        this.entities.loadNewDico(useData.dicoData);
                        this.entities.postProcess();
                        this.parameterFactory.createClientParameters(useData.parameters);
                        useData.parameters = undefined;
                        delete useData.parameters;
                        this.groupKeyFactory.resetAndLoad(useData.groupKeys === undefined ? [] : useData.groupKeys);
                        return [2, useData];
                    case 2:
                        err_4 = _a.sent();
                        console.error(err_4.stack || err_4);
                        err_4 = err_4.stack === undefined ? new Error(err_4) : err_4;
                        throw err_4;
                    case 3: return [2];
                }
            });
        });
    };
    Api.prototype.closeDB = function (dbName) {
        this.freeCxionData();
        return this.restApi.closeDB(dbName);
    };
    Api.prototype.logout = function () {
        this.freeCxionData();
        return this.restApi.logout();
    };
    Api.prototype.execRollupQuery = function (rolQCN, reliabilityMin) {
        if (reliabilityMin === void 0) { reliabilityMin = 9; }
        return new Promise(function (f, reject) {
            if (rolQCN === 897) {
                var result = {
                    data: [
                        { group: "Robotic", value: 456.78 },
                        { group: "Hotel", value: 1234.99 },
                        { group: "Other", value: 894 },
                    ],
                    reliability: reliabilityMin,
                };
                return f(result);
            }
            if (rolQCN === 678) {
                var result = {
                    data: [
                        { group: "", value: 123456.78 },
                    ],
                    reliability: 5,
                };
                return f(result);
            }
            return reject("bad parameters");
        });
    };
    Api.prototype.sendFile = function (fileName, buffer) {
        return this.restApi.sendFile(fileName, buffer);
    };
    Api.prototype.sendFile_b64 = function (fileName, buffer) {
        return this.restApi.sendFile_b64(fileName, buffer);
    };
    Api.prototype.getFile = function (fileName) {
        return this.restApi.getFile(fileName);
    };
    Api.prototype.getFileUrl = function (fileName) {
        return this.restApi.getFileUrl(fileName);
    };
    Api.prototype.getUserLogo = function () {
        return this.restApi.getUserLogo();
    };
    Api.prototype.getFilesList = function () {
        return this.restApi.getFilesList();
    };
    Api.prototype.deleteFile = function (fileName) {
        return this.restApi.deleteFile(fileName);
    };
    Api.prototype.getAllDocuments = function (eCN, options, byPassRestrictedMode, srvType) {
        if (options === void 0) { options = ""; }
        if (byPassRestrictedMode === void 0) { byPassRestrictedMode = false; }
        if (srvType === void 0) { srvType = 1; }
        if (eCN === 0) {
            throw new Error("not allowed on system entities");
        }
        if (eCN === undefined || eCN === null) {
            throw new Error("invalid parameter");
        }
        if (byPassRestrictedMode) {
            if (options === null) {
                options = "noUid";
            }
            else {
                options += "&noUid";
            }
        }
        return this.restApi.getAllDocuments(eCN, options, srvType);
    };
    Api.prototype.getOneDocument = function (eCN, docId, options, byPassRestrictedMode, srvType) {
        if (options === void 0) { options = ""; }
        if (byPassRestrictedMode === void 0) { byPassRestrictedMode = false; }
        if (srvType === void 0) { srvType = 1; }
        if (eCN === 0) {
            throw new Error("not allowed on system entities");
        }
        if (byPassRestrictedMode) {
            if (options === null) {
                options = "noUid";
            }
            else {
                options += "&noUid";
            }
        }
        return this.restApi.getOneDocument(eCN, docId, options, srvType);
    };
    Api.prototype.insertDocuments = function (eCN, data, options, srvType) {
        if (options === void 0) { options = ""; }
        if (srvType === void 0) { srvType = 1; }
        if (eCN === 0) {
            throw new Error("not allowed on system entities");
        }
        return this.restApi.insertDocuments(eCN, data, options, srvType);
    };
    Api.prototype.replaceDocument = function (eCN, data, options, srvType) {
        if (options === void 0) { options = ""; }
        if (srvType === void 0) { srvType = 1; }
        if (eCN === 0) {
            throw new Error("not allowed on system entities");
        }
        return this.restApi.replaceDocument(eCN, data, options, srvType);
    };
    Api.prototype.updateOneDocument = function (eCN, id, options, srvType) {
        if (options === void 0) { options = ""; }
        if (srvType === void 0) { srvType = 1; }
        if (eCN === 0) {
            throw new Error("not allowed on system entities");
        }
        return this.restApi.updateOneDocument(eCN, id, options, srvType);
    };
    Api.prototype.updateMultipleDocuments = function (eCN, options, srvType) {
        if (options === void 0) { options = ""; }
        if (srvType === void 0) { srvType = 1; }
        if (eCN === 0) {
            throw new Error("not allowed on system entities");
        }
        return this.restApi.updateMultipleDocuments(eCN, options, srvType);
    };
    Api.prototype.deleteOneDocument = function (eCN, docId, options, srvType) {
        if (options === void 0) { options = ""; }
        if (srvType === void 0) { srvType = 1; }
        if (eCN === 0) {
            throw new Error("not allowed on system entities");
        }
        return this.restApi.deleteOneDocument(eCN, docId, options, srvType);
    };
    Api.prototype.deleteMultipleDocuments = function (eCN, options, srvType) {
        if (options === void 0) { options = ""; }
        if (srvType === void 0) { srvType = 1; }
        if (eCN === 0) {
            throw new Error("not allowed on system entities");
        }
        return this.restApi.deleteMultipleDocuments(eCN, options, srvType);
    };
    Api.prototype.loadDBTemplate = function (data) {
        return this.restApi.loadDBTemplate(data);
    };
    Api.prototype.getDBTemplate = function () {
        return this.restApi.getDBTemplate();
    };
    Api.prototype.getPgAccessInternals = function () {
        return this.restApi.getPgAccessInternals();
    };
    Api.prototype.dump = function (bDisplay) {
        if (bDisplay === void 0) { bDisplay = true; }
        return this.restApi.dump(bDisplay);
    };
    Api.prototype.dumpList = function (bDisplay) {
        if (bDisplay === void 0) { bDisplay = true; }
        return this.restApi.dumpList(bDisplay);
    };
    Api.prototype.restore = function (dumpName) {
        return this.restApi.restore(dumpName);
    };
    Api.prototype.checkDB = function (dbName) {
        if (dbName === void 0) { dbName = null; }
        return this.restApi.checkDB(dbName === null ? this.restApi.getDBName() : dbName);
    };
    Api.prototype.createUserApplication = function (userName, appName, password, instanceName) {
        return __awaiter(this, void 0, void 0, function () {
            var loginData, err_5, srvUrs, i, tmpUser, myUsr, normalizedAppName, tmpApp, myApp, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        if (!this.restApi.isInstanceLoaded(instanceName)) {
                            throw new Error("Unknown or not loaded instance: " + instanceName);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.login({ domain: "titi", instanceName: instanceName })];
                    case 2:
                        loginData = _a.sent();
                        if (loginData.length > 0) {
                            throw new Error("user already exists");
                        }
                        return [3, 4];
                    case 3:
                        err_5 = _a.sent();
                        ;
                        return [3, 4];
                    case 4: return [4, flUser.UserClass.load(userName)];
                    case 5:
                        srvUrs = _a.sent();
                        for (i = 0; i < srvUrs.length; i++) {
                            if (srvUrs[i].name === userName) {
                                throw new Error("user name already used");
                            }
                        }
                        tmpUser = new flUser.UserClass({ name: userName, password: password, type: "user" });
                        return [4, tmpUser.create()];
                    case 6:
                        myUsr = _a.sent();
                        normalizedAppName = appName.replace(/ /g, "_");
                        normalizedAppName = normalizedAppName.replace(/;/g, "_");
                        normalizedAppName = normalizedAppName.replace(/\'/g, "-");
                        normalizedAppName = normalizedAppName.replace(/\"/g, "-");
                        normalizedAppName = normalizedAppName.replace(/\\/g, "-");
                        tmpApp = new flApp.ApplicationEntity({
                            access: [{ userId: myUsr.id, accessLevel: 255, jSon: {}, userName: myUsr.name }],
                            dbName: appName.startsWith("testMocha_") ? "db_tmp_" + normalizedAppName : "",
                            description: appName,
                            name: appName,
                            ownerUserId: myUsr.id,
                        });
                        return [4, tmpApp.create()];
                    case 7:
                        myApp = _a.sent();
                        return [4, this.login({ user: userName, password: password, instanceName: instanceName })];
                    case 8:
                        _a.sent();
                        return [4, this.use(appName)];
                    case 9:
                        _a.sent();
                        return [2, { application: myApp, user: myUsr }];
                    case 10:
                        err_6 = _a.sent();
                        console.error(err_6.stack || err_6);
                        err_6 = err_6.stack === undefined ? new Error(err_6) : err_6;
                        throw err_6;
                    case 11: return [2];
                }
            });
        });
    };
    Api.prototype.svcExec = function (svcName, api, groupKeyToCheck, data, nextRun, repeat, processInfo) {
        if (nextRun === void 0) { nextRun = new Date().getTime(); }
        if (repeat === void 0) { repeat = null; }
        if (processInfo === void 0) { processInfo = []; }
        return __awaiter(this, void 0, void 0, function () {
            var groupKey, gkFcn, tmpGK, result, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        groupKey = {
                            id: -1,
                            service: svcName,
                            action: "",
                            eCN: -1,
                            fCN: [],
                            split: new Array(),
                            option: {},
                        };
                        if (groupKeyToCheck !== null && groupKeyToCheck !== undefined) {
                            if (groupKey.action !== undefined) {
                                groupKey = groupKeyToCheck;
                            }
                            else {
                                throw new Error("invalid groupKey");
                            }
                        }
                        groupKey.service = svcName;
                        if (!(groupKey.action.length > 0)) return [3, 2];
                        return [4, this.groupKeyFactory.reloadAll()];
                    case 1:
                        _a.sent();
                        gkFcn = groupKey.fCN.length === 0 ? -1 : groupKey.fCN[groupKey.fCN.length - 1];
                        tmpGK = this._groupKeys.getAllPerAction(groupKey.service, groupKey.action, gkFcn);
                        if (tmpGK !== undefined) {
                            if (groupKey.fCN.length > 0 && tmpGK.fCN.length > 0 && tmpGK.fCN[tmpGK.fCN.length - 1] !== groupKey.fCN[groupKey.fCN.length - 1]) {
                                throw new Error("groupdKey: last fcn in fcnPath mitchmatch " + tmpGK.fCN.join(",") + "-" + groupKey.fCN.join(","));
                            }
                            groupKey.id = tmpGK.id;
                        }
                        else {
                            groupKey.id = 0;
                        }
                        _a.label = 2;
                    case 2: return [4, this.restApi.svcExec(svcName, api, groupKey, data, nextRun, repeat, processInfo)];
                    case 3:
                        result = _a.sent();
                        return [2, result];
                    case 4:
                        err_7 = _a.sent();
                        console.error(err_7.stack);
                        throw err_7;
                    case 5: return [2];
                }
            });
        });
    };
    Api.prototype.svcGetAllRequests = function (svcName, options) {
        if (options === void 0) { options = ""; }
        throw new Error("not available");
    };
    Api.prototype.svcGetOneRequest = function (svcName, requestId) {
        return this.restApi.svcGetAllRequests(svcName, "q=id = " + requestId);
    };
    Api.prototype.svcDeleteOneRequest = function (svcName, requestId) {
        return this.restApi.svcDeleteOneRequest(svcName, requestId);
    };
    Api.prototype.getSvcList = function () {
        return this.restApi.getSvcList();
    };
    Api.prototype.getSvcConditions = function (svcName) {
        return this.restApi.getSvcConditions(svcName);
    };
    Api.prototype.getWHForAction = function (svcName, action) {
        return this.restApi.getWHForAction(svcName, action);
    };
    Api.prototype.getWHForRequest = function (svcName, requestId) {
        return this.restApi.getWHForRequest(svcName, requestId);
    };
    Api.prototype.getWHFiltered = function (svcName, status, groupKey) {
        return this.restApi.getWHFiltered(svcName, status, groupKey);
    };
    Api.prototype.getWHInfos = function (svcName, ids) {
        return this.restApi.getWHInfos(svcName, ids);
    };
    Api.prototype.deleteGroupKeys = function (svcName, groupKeyId) {
        return this.restApi.deleteGroupKeys(svcName, groupKeyId);
    };
    Api.prototype.getObject = function (id) {
        var e_1, _a, e_2, _b;
        try {
            for (var _c = __values(this.entities.getAllEntities()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var myEnt = _d.value;
                if (myEnt.id === id) {
                    return myEnt;
                }
                try {
                    for (var _e = (e_2 = void 0, __values(myEnt.fields)), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var myFi = _f.value;
                        if (myFi.id === id) {
                            return myFi;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return null;
    };
    Api.prototype.getObjects = function (ids) {
        var _this = this;
        var result = [];
        ids.forEach(function (id) {
            var e_3, _a, e_4, _b;
            try {
                for (var _c = __values(_this.entities.getAllEntities()), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var myEnt = _d.value;
                    if (myEnt.id === id) {
                        result.push(myEnt);
                        continue;
                    }
                    try {
                        for (var _e = (e_4 = void 0, __values(myEnt.fields)), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var myFi = _f.value;
                            if (myFi.id === id) {
                                result.push(myFi);
                                continue;
                            }
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_3) throw e_3.error; }
            }
        });
        return result;
    };
    Api.prototype.buildMasterDetailDico = function () {
        var e_5, _a, e_6, _b;
        var mdData = [];
        try {
            for (var _c = __values(this.entities.getAllEntities()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var myEnt = _d.value;
                try {
                    for (var _e = (e_6 = void 0, __values(myEnt.getFieldByType("pointer"))), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var myFi = _f.value;
                        var myFiPt = myFi;
                        var cardi = myFiPt.pointer[0].ptCardinality + myFiPt.pointer[1].ptCardinality;
                        if (cardi === "1N" || cardi === "N1") {
                            var i1 = 0;
                            var i2 = 1;
                            var i3 = 1;
                            if (cardi === "N1") {
                                i1 = 1;
                                i2 = 0;
                                i3 = -1;
                            }
                            mdData.push({
                                detailSingular: this.entities.getByEcn(myFiPt.pointer[i2].ptEcn).singular,
                                detailTable: myFiPt.pointer[i2].ptEcn,
                                masterSingular: this.entities.getByEcn(myFiPt.pointer[i1].ptEcn).singular,
                                masterTable: myFiPt.pointer[i1].ptEcn,
                                relationDirection: i3,
                                relationField: myFiPt.id,
                                relationVerb: myFiPt.pointer[i2].ptVerb,
                                storedInMaster: (myFiPt.pointer[i1].ptEcn === myEnt.id),
                            });
                        }
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return mdData;
    };
    Api.prototype.freeCxionData = function () {
        this.entities.loadNewDico([]);
        this.parameterFactory.resetAndLoad([]);
        this.groupKeyFactory.resetAndLoad([]);
        this.curListField.clear();
    };
    return Api;
}());
exports.Api = Api;
